import { IconProps } from "./types";

export default function IcoReclinedSeat({
	color = "#4B5563",
	width = "14",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 14 16"
			fill="none"
		>
			<g clipPath="url(#clip0_641_1086)">
				<path
					d="M7.74952 1.5V8H9.24952V1.83438C9.9964 2.26562 10.4995 3.075 10.4995 4V8H11.9995V4C11.9995 1.79063 10.2089 0 7.99952 0H5.99952C3.79015 0 1.99952 1.79063 1.99952 4V8H3.49952V4C3.49952 3.075 4.00265 2.26562 4.74952 1.83438V8H6.24952V1.5H7.74952ZM1.49952 9C1.1214 9 0.774521 9.2125 0.605771 9.55313L0.105771 10.5531C-0.0504787 10.8625 -0.0317287 11.2312 0.149521 11.525C0.330771 11.8187 0.652646 12 0.999521 12V15C0.999521 15.5531 1.4464 16 1.99952 16C2.55265 16 2.99952 15.5531 2.99952 15V12H10.9995V15C10.9995 15.5531 11.4464 16 11.9995 16C12.5526 16 12.9995 15.5531 12.9995 15V12C13.3464 12 13.6683 11.8219 13.8495 11.525C14.0308 11.2281 14.0495 10.8625 13.8933 10.5531L13.3933 9.55313C13.2245 9.2125 12.8776 9 12.4995 9H1.49952Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_641_1086">
					<path d="M0 0H14V16H0V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
